import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { toastMessage } from "@iscr/xAppLib/helpers/toast_message";
import debounce from "@iscr/xAppLib/libs/debounce";
import { useEffect } from "react";
export const DeviceRegistrationChangeToast = () => {
    useEffect(() => {
        const handler = debounce(({ org }, lastOrg) => {
            // Ignore the initial load when the app starts and the device org is loaded for the first time
            // - is false when unset
            // - can be an empty object before the org is fully loaded
            if (typeof lastOrg === "boolean" ||
                (lastOrg && JSON.stringify(lastOrg) !== "{}" && (!org || lastOrg.oid !== org.oid))) {
                const lastOrgName = typeof lastOrg === "boolean" ? "" : (lastOrg === null || lastOrg === void 0 ? void 0 : lastOrg.name) || "";
                const orgName = org ? org.name : lastOrgName;
                const type = org ? "registered to" : lastOrg ? "deregistered from" : null;
                if (type) {
                    toastMessage(_jsxs("div", { children: [_jsxs("div", { children: ["Device ", type, ":"] }), _jsx("div", { className: "font-bold", children: orgName })] }), "info");
                }
            }
        }, 300);
        app.on(app.events.DVC_LDD, handler);
        return () => {
            app.off(app.events.DVC_LDD, handler);
        };
    }, []);
    return null;
};
